import { render, staticRenderFns } from "./404page.vue?vue&type=template&id=bff9fbf2&scoped=true&"
import script from "./404page.vue?vue&type=script&lang=js&"
export * from "./404page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff9fbf2",
  null
  
)

export default component.exports